import { axiosInstance } from "./httpClient";
import { API_URL } from "../utils/constants";
import { RecurringTimeSlotDto } from "../pages/availablility";
import { ILesson } from "../types/schedule";
import axios, { AxiosError } from "axios";

interface timeSlots {
  // id?:string
  start: string;
  end: string;
}

interface updateTimeSlots extends timeSlots {
  id: string;
}

const getToken = () => {
  return localStorage.getItem("token");
};

const getTeacherId = () => {
  return localStorage.getItem("id");
};

export const timeSlot = async (payload: { role: string | undefined; timeSlots: timeSlots[] }) => {
  let token = getToken();
  try {
    let response = await axiosInstance.post(`${API_URL}/availability`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error?.response?.data?.message || "something went wrong");
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};

export const recurring = async (payload: {
  role: string | undefined;
  recurring: RecurringTimeSlotDto;
}) => {
  let token = getToken();
  try {
    let response = await axiosInstance.post(
      `${API_URL}/availability/recurring`,
      {
        role: payload.role,
        ...payload.recurring,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);
    if (axios.isAxiosError(error)) {
      throw new Error(error?.response?.data?.message || "something went wrong");
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};

export const getSchedules = async () => {
  const id = getTeacherId();
  const token = getToken();
  try {
    let response = await axios.get(`${API_URL}/teachers/availability?teacherId=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//schedule

export const fetchCompletedLessons = async () => {
  try {
    const { data } = await axiosInstance(`${API_URL}/bookings/merchants?completed=true`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return data.result.bookings as ILesson[];
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchIncompleteLessons = async () => {
  try {
    const { data } = await axiosInstance(`${API_URL}/bookings/merchants?completed=false`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return data.result.bookings as ILesson[];
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteSlots = async (slotId: string) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/availability/${slotId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const updateTimeSlots = async (payload: updateTimeSlots) => {
  try {
    const response = await axiosInstance.patch(
      `${API_URL}/availability/${payload?.id}`,
      {
        start: payload?.start,
        end: payload?.end,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (error: any) {
    throw new Error(error);
  }
};